import React, { useState, useEffect } from 'react';
import './bingo.css';

const Bingo = ({ items, size, storageKey }) => {
  const [bingoItemsState, setBingoItemsState] = useState([]);
  const [marked, setMarked] = useState([]);
  const [isBingo, setIsBingo] = useState(false);

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  
  useEffect(() => {
    const savedData = localStorage.getItem(storageKey);
    if (savedData) {
      const { bingoItems, marked, date } = JSON.parse(savedData);
      const today = new Date().toLocaleDateString();
      if (date === today) {
        setBingoItemsState(bingoItems);
        setMarked(marked);
      } else {
        generateNewCard();
      }
    } else {
      generateNewCard();
    }
  
    function generateNewCard() {
      const shuffledItems = shuffleArray([...items]);
      const newItems = shuffledItems.slice(0, size * size).map((text) => ({ text }));
      setBingoItemsState(newItems);
      setMarked(Array(size * size).fill(false));
      const date = new Date().toLocaleDateString();
      localStorage.setItem(
        storageKey,
        JSON.stringify({ bingoItems: newItems, marked: Array(size * size).fill(false), date })
      );
    }
  }, [items, size, storageKey]);

  const handleClick = (index) => {
    const newMarked = [...marked];
    newMarked[index] = !newMarked[index];
    setMarked(newMarked);

    const today = new Date().toLocaleDateString('nl-NL');
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        bingoItems: bingoItemsState,
        marked: newMarked,
        date: today,
      })
    );
  };

  useEffect(() => {
    const checkBingo = () => {
      const rows = Array.from({ length: size }, (_, i) =>
        Array.from({ length: size }, (_, j) => i * size + j)
      );
      const columns = Array.from({ length: size }, (_, i) =>
        Array.from({ length: size }, (_, j) => j * size + i)
      );
      const diagonals = [
        Array.from({ length: size }, (_, i) => i * size + i),
        Array.from({ length: size }, (_, i) => (i + 1) * (size - 1)),
      ];
      const winningLines = [...rows, ...columns, ...diagonals];
      return winningLines.some((line) => line.every((index) => marked[index]));
    };

    setIsBingo(checkBingo());
  }, [marked, size]);

  return (
    <div className={`bingo-container ${isBingo ? 'bingo-active' : ''}`}>
      <div className="bingo-header">Top 2000 Bingo</div>
      <div
        className="bingo-grid"
        style={{
          gridTemplateColumns: `repeat(${size}, minmax(100px, auto))`,
          gridTemplateRows: `repeat(${size}, 1fr)`,
        }}
      >
        {bingoItemsState.map((item, index) => (
          <div
            key={index}
            className={`bingo-cell ${marked[index] ? 'marked' : ''}`}
            onClick={() => handleClick(index)}
          >
            {item.text}
          </div>
        ))}
      </div>
    </div>
  );
};

const CountdownTimer = () => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0); // Stel in op middernacht
    const difference = midnight - now;

    return {
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Opruimen bij unmount
  }, []);

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div className="countdown-timer">
      <div className="timer">
        <span>Nog </span>
        <span>{String(timeLeft.hours).padStart(2, '0')}:</span>
        <span>{String(timeLeft.minutes).padStart(2, '0')}:</span>
        <span>{String(timeLeft.seconds).padStart(2, '0')}</span>
        <span> tot een nieuwe kaart </span>
        <span>
        <button className="refresh-button" onClick={refreshPage}>
  🔄
</button>
</span>

      </div>
    </div>
  );
};

const App = () => {
  const top2000Items = [
    'Een nummer van Queen.',
'Twee kussende mensen in het café.',
'Een hakkuh-nummer.',
'Een nummer dat live wordt gezongen.',
'Een nummer dat iemand hardop meezingt.',
'Iemand doet een dansje.',
'Een nummer uit de jaren 70.',
'Een nummer met een saxofoonsolo.',
'Een nummer dat langer is dan 7 minuten.',
'Een nummer van ABBA.',
'Een kerstnummer.',
'Een coverversie.',
'Een Nederlandse artiest in de lijst.',
'Een nummer met een iconische gitaarsolo.',
'Een ballad.',
'Een nieuwe binnenkomer in de Top 2000.',
'Een nummer dat voor het eerst in de lijst staat.',
'Een songfestival nummer.',
'Een applaus in het café.',
'Een DJ vertelt een anekdote over een nummer.',
'Een nummer met "Love" in de titel.',
'Een nummer met "Rain" in de tekst.',
'Een nummer uit een Top 10.',
'Een nummer van The Beatles.',
'Iemand klapt mee op de maat.',
'Een luchtgitaaractie.',
'Een nummer dat in een film voorkomt.',
'Een nummer van David Bowie.',
'Een iconische baslijn.',
'Een nummer met orkestbegeleiding.',
'Een nummer over afscheid.',
'Een duet.',
'Een nummer van Bruce Springsteen.',
'Een nummer met "Rock" in de titel.',
'Iemand draagt een Kerst-trui.',
'Een nummer van Fleetwood Mac.',
'Een huwelijksaanzoek in de chat.',
'Een tekstregel wordt verkeerd meegezongen.',
'Een nummer uit de jaren 90.',
'Een nummer met een synthesizerintro.',
'Een optreden op de piano.',
'Een spontaan polonaise.',
'Een nummer dat ooit ergens op #1 stond.',
'Een nummer met een legendarische videoclip.',
'Een nummer met dierengeluiden.',
'Een nummer over reizen.',
'Een Frans nummer.',
'Een nummer dat je kippenvel geeft.',
'Een nummer met "Heaven" in de tekst.',
'Een liedje dat je doet huilen.',
'Een zanger met een hoed.',
'Een nummer dat wordt gedraaid tijdens de jaarwisseling.',
'Een klassiek nummer dat is bewerkt.',
'Een nummer van U2.',
'Een liveopname.',
'Een funky baslijn.',
'Een nummer met een tijdsaanduiding in de tekst.',
'Een nummer over een stad.',
'Een nummer waarin een kinderstem voorkomt.',
'Een nummer met "Fire" in de tekst.',
'Een medley.',
'Een drumsolo.',
'Een zanger met een zonnebril.',
'Een nummer met een accordeon.',
'Een zangeres met een krachtige stem.',
'Een nummer met een politieke boodschap.',
'Een nummer met een exotische ritme.',
'Een nummer met een mondharmonica.',
'Een nummer dat begint met stilte.',
'Een klassieker van Michael Jackson.',
'Een nummer dat gaat over dromen.',
'Een nummer dat gebaseerd is op een waargebeurd verhaal.',
'Een nummer van een boyband.',
'Een nummer dat iedereen kent.',
'Een zanger met lang haar.',
'Een nummer van Coldplay.',
'Een nummer dat opvalt door zijn eenvoud.',
'Een nummer dat ineens stopt.',
'Een nummer dat live beter klinkt dan op de plaat.',
'Een nummer van een festivalheadliner.',
'Een nummer met viool.',
'Een nummer met een explosief einde.',
'Een nummer van een band met meer dan 5 leden.',
'Een klassieker uit de jaren 60.',
'Een nummer dat begint met een fluister.',
'Een nummer dat iedereen laat dansen.',
'Een obscure artiest in de Top 2000.',
'Een nummer met "Summer" in de titel.',
'Een nummer van The Rolling Stones.',
'Een nummer dat vaak als karaoke wordt gezongen.',
'Een nummer met een gospelkoor.',
'Een nummer over vrijheid.',
'Een nummer met een kleur in de titel.',
'Een nummer waarin de artiest zijn naam zingt.',
'Een nummer over de maan.',
'Een "one-hit wonder".',
'Een nummer dat je herkent aan de eerste seconde.',
'Een nummer van een Nederlandse band.',
'Een nummer dat eindigt met applaus.',
'De DJ zwaait mee met een nummer.',
'Een meertalig nummer',
'Iemand met 2 bier in zijn hand',
'een veel gecoverd nummer',
'De DJ imiteert de zanger',
'Zwaaien met camera lampjes in het café.',
'Een opmerking over gourmetten bij Huub',
'Een liedje van een cabaretier ',
'Een liedje met een christelijke boodschap',
'Closeup camera met een baby',
'Een nummer dat korter is dan 3 minuten',
'Een liedje met 1 woord als titel',
'Een huisdier op beeld in het café via zoom',
'Een liedje in een streektaal of met een zwaar accent ',
'Iemand gaat op de foto met de DJ',
'Een bekende in het café ',
'Een artiest die gecanceld is',
'Een Top2000 sjaal',
'De DJ zwaait naar de schermen',
'Een nummer waar je op gestemd hebt',
'de DJ gaat het cafe in',
'Vuurwerk in het cafe'
  ];

  return (
    <div className="App">
      <Bingo items={top2000Items} size={3} storageKey="bingo-top2000" />
      <div className="subText">
        <strong>🎶  Heb jij bingo? Deel je kaart!</strong><br />
        <strong>Gebruik <a href="https://www.instagram.com/explore/search/keyword/?q=%23top2000bingo" rel="noreferrer" target="_blank">#top2000bingo</a> en Tag <a href="https://www.instagram.com/top2000bingo" rel="noreferrer" target="_blank">@top2000bingo</a></strong><br />
        <CountdownTimer />
        <a href="https://js-4.nl" target="_blank" rel="noreferrer">Made by JS-4</a>
      </div>
    </div>
  );
};

export default App;
